import { type PresApiSearchProduct } from '@/modules/search/aliases';

type PresApiSize = NonNullable<PresApiSearchProduct['sizes']>[number];
type SizeInput = string[] | PresApiSearchProduct['sizes'];

const AVAILABLE_STATUS: PresApiSize['status'] = 'STATUS_ONSALE';

function getAvailableSizes(sizes: SizeInput): SizeInput {
  if (!sizes || sizes.length === 0) {
    return sizes;
  }
  if (typeof sizes[0] === 'string') {
    return sizes;
  }

  return (sizes as PresApiSize[]).filter(
    (size) => size.status === AVAILABLE_STATUS
  );
}

export function getSizeString({
  sizes,
  multipleSizesString,
}: {
  sizes: SizeInput | undefined;
  multipleSizesString: string;
}) {
  if (!sizes) {
    return;
  }

  const availableSizes = getAvailableSizes(sizes);

  if (availableSizes?.length && availableSizes.length > 1) {
    return multipleSizesString;
  }

  /**
   * Some products, e.g. accessories, have no sizes and the API expresses this as product.sizes: [].
   * In these instances, we should return an empty string so that we can differentiate between
   * these products and products that have sizes deliberately ommitted.
   */
  const firstSize = availableSizes?.[0];
  if (!firstSize) {
    return '';
  }

  return typeof firstSize === 'string' ? firstSize : (firstSize.name ?? '');
}
